import { createSlice } from '@reduxjs/toolkit'

export const gameStateSlice = createSlice({
  name: 'gameState',
  initialState: {
    players: [{
      id: 0,
      name: "",
      host: false,
      faker: false,
      colour: "#0000FF",
      voted: false,
      myVote: "",
    }],
    room: null,
    turn: 0,
    drawing: "",
    ready: false,
    word: "",
    voting: false,
    // hate this below
    voteComplete: false,
    messages: [],
    faker: {},
    round: 1,
    status: '',
    config: {},
  },
  reducers: {
    initGameState: (state, action) => {
      const newState = action.payload;
      return newState
    },
    updateDrawing: (state, action) => {
      state.drawing = action.payload
    },
    updateReadyState: (state, action) => {
      state.ready = action.payload
    },
    updateVotingState: (state, action) => {
      state.voting = action.payload
    },
    updateVoteComplete: (state, action) => {
      state.voteComplete = action.payload
    },
    updateTurn: (state, action) => {
      if (action.payload >= state.players.length) {
        state.turn = 0;
        state.round++;
      }
      else {
        state.turn = action.payload
      }
    },
    setSecretWord: (state, action) => {
      state.word = action.payload
    },
    setGameFaker: (state, action) => {
      state.faker = action.payload
    },
    updateFaker: (state, action) => {
      state.players.forEach(p => {
        if (action.payload.id === p.id) {
          p.faker = true;
        }
      });
    },
    updateRound: (state) => {
      state.round++;
    },
    addPlayer: (state, action) => {
      state.players.push(action.payload);
    },
    updatePlayers: (state, action) => {
      state.players = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload)
    },
    updateMessages: (state, action) => {
      state.messages = action.payload
    },
    setGameStatus: (state, action) => {
      state.status = action.payload
    },
    setGameRoom: (state, action) => {
      state.room = action.payload
    },
    setConfig: (state, action) => {
      state.config = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { initGameState, updateDrawing, updateReadyState, updateVotingState, updateVoteComplete, updateTurn, updateRound, addPlayer, addMessage, updateMessages, setSecretWord, updatePlayers, setGameFaker, updateFaker, setGameStatus, setGameRoom, setConfig } = gameStateSlice.actions

export default gameStateSlice.reducer